import { CandleWorkerApi } from '@voladeum/client';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

import { CandleWorker } from './types';

export const normalizeCandleWorkers = (data: CandleWorkerApi[]): CandleWorker[] =>
  data.map((d) => normalizeCandleWorker(d));

export const normalizeCandleWorker = (row: CandleWorkerApi): CandleWorker => {
  return {
    ...row,
    since_date: moment(row.since_milliseconds).utc().format('MM/DD/YYYY'),
    to_date: moment(row.to_milliseconds).utc().format('MM/DD/YYYY'),
    uuid: uuidv4(),
  };
};
